var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lead"},[_vm._v(_vm._s(_vm.$t('question.zeroPool.error')))]),_vm._v(" "),(_vm.previousQuestionId)?_c('p',[_c('router-link',{attrs:{"to":{name:'QuestionShow', params: {id: _vm.previousQuestionId}}}},[_c('font-awesome-icon',{attrs:{"icon":"angle-left"}}),_vm._v(" "+_vm._s(_vm.$t('question.zeroPool.previous')))],1)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5407848","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/ZeroPool.vue
// module id = 894
// module chunks = 0